/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowADownLeftIcon64Regular = forwardRef('ArrowADownLeftIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M15.56 50.561A4.481 4.481 0 0 0 17.5 51h26a1.5 1.5 0 0 1 0 3h-26a7.5 7.5 0 0 1-7.5-7.5v-26a1.5 1.5 0 0 1 3 0v26c0 .695.157 1.353.438 1.94l36.001-36a1.5 1.5 0 0 1 2.122 2.12L15.56 50.562Z" })));
});
